<div class="flexable p-2">
  <div class="centered text-center justify-center flex rounded-xl rounded-tab  w-fit">
  <!-- Warehouse Selector -->
  <div class="flex gap-x-2 p-2  items-center">
    <!-- <mat-form-field appearance="outline">
      <mat-label>Select Warehouse</mat-label>
      <mat-select [(ngModel)]="filtering.warehouse">
        <mat-option
          *ngFor="let warehouse of warehouses$ | async"
          [value]="warehouse?.uniqueId"
        >
          {{ warehouse?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <div class="flex gap-x-2 p-2 items-center">
<select
  [(ngModel)]="filtering.warehouse"
  (ngModelChange)="onFilterChange($event, 'warehouse')"
  class="border border-[#E6E6E6] text-black px-[12px] py-[8px] rounded-full bg-[#F1F1F1]"
>
  <option *ngFor="let warehouse of warehouses$ | async" [value]="warehouse?.uniqueId">
    {{ warehouse?.name }}
  </option>
</select>
</div>

  </div>
  <div class="flex gap-x-2 p-2 items-center" *ngIf="filtering.warehouse">
  <span class="text-black">Sensor:</span>
  <select
    [(ngModel)]="filtering.sensor"
    (ngModelChange)="onFilterChange($event, 'sensor')"
    class="border border-[#E6E6E6] text-black px-[12px] py-[8px] rounded-full bg-[#F1F1F1]"
  >
    <option *ngFor="let sensor of warehouseSensors$ | async" [value]="sensor.uniqueId">
      {{ sensor.sensorName }}
    </option>
  </select>
</div>

  <div class="flex items-center gap-2 text-primary-600 py-2 px-3 rounded-xl">
    <input
      type="datetime-local"
      [(ngModel)]="filtering.dateFrom"
      [max]="filtering.dateTo"
      class="border border-[#E6E6E6] text-black px-[12px] py-[8px] rounded-full bg-[#F1F1F1]"
    />
    <input
      type="datetime-local"
      [(ngModel)]="filtering.dateTo"
      [min]="filtering.dateFrom"
      class="border border-[#E6E6E6] text-black px-[12px] py-[8px] rounded-full bg-[#F1F1F1]"
    />
  </div>

  <div class="mt-2.5">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal bg-[#dbdbdb] text-[#9b9b9b]"
      [ngClass]="{
        '!bg-[#025590] !text-white': filtering.warehouse && filtering.warehouse !== 'null',
        ' cursor-not-allowed': !filtering.warehouse && filtering.warehouse === 'null'
      }" [disabled]="!filtering.warehouse || filtering.warehouse === 'null'"
    >
      <!-- <mat-icon>summarize</mat-icon> -->
      Generate
    </button>
    <!-- <button (click)="generatePDF()" color="warn" mat-raised-button class="ml-2" > -->
    <!--     <mat-icon>picture_as_pdf</mat-icon> -->
    <!--     Generate PDF -->
    <!-- </button> -->
  </div>
</div>

<div class="flex justify-between items-center px-8 border-t pt-6 mt-4">
  <img src="/assets/images/emblem.png" class="w-24" />
  <div class="flex flex-col gap-1 items-center">
    <span class="font-bold text-2xl text-[#005590]"
      >The United Republic of Tanzania</span
    >
    <span class="font-bold text-xl text-[#005590]"
      >Medical Stores Department</span
    >
    <span class="font-bold text-[#005590]"> Zone  Analysis Report </span>
  </div>
  <img src="/assets/images/logo.svg" class="h-full" />
</div>

<div *ngIf="noDataMessage" class="flex flex-col items-center justify-center py-20 gap-4">
  <div class="flex items-center justify-center w-24 h-24 rounded-full bg-blue-50">
    <mat-icon class="!text-5xl !w-12 !h-12 text-[#025590]">search_off</mat-icon>
  </div>
  <p class="text-base font-semibold text-gray-500 text-center max-w-sm">{{ noDataMessage }}</p>
</div>

<div class="grid grid-cols-12 gap-4 mt-12" *ngIf="reportData.length > 0">
  <div class="col-span-12 md:col-span-8 bg-gray-50">
    <app-bar-graph
      title="Average Temperatures per Warehouse Zone"
      [data]="temperatureChartData"
      [xAxis]="xAxis"
      xAxisTitle="Average Temperature (°C)"
      chart_type="bar"
      [horizontal]="true"
      [gridX]="true"
      [gridY]="true"
      [showXlabel]="true"
      [showYlabel]="true"
    >
    </app-bar-graph>

    <mat-divider></mat-divider>

    <app-bar-graph
      title="Average Humidity per Warehouse Zone"
      [data]="humidityChartData"
      [xAxis]="xAxis"
      xAxisTitle="Average Humidity (%)"
      chart_type="bar"
      [horizontal]="true"
      [gridX]="true"
      [gridY]="true"
      [showXlabel]="true"
      [showYlabel]="true"
    >
    </app-bar-graph>
  </div>

  <div class="col-span-12 md:col-span-4">
    <div class="p-2">
      <div class="mb-3">
        <div class="flex gap-2 flex-wrap">
          <span class="font-bold">Number of Alerts per Warehouse Zone</span>
        </div>

        <div class="mt-2 bg-gray-50 flex items-center gap-1 p-1 rounded-lg">
          <div class="bg-gray-100 rounded-lg text-secondary-600 p-2">
            <fa-icon [icon]="faBell"></fa-icon>
          </div>
          <div class="flex flex-col border-r pr-2 mr-2">
            <span class="text-sm">Total Alerts</span>
            <span class="font-bold">{{ getTotalAlerts() }}</span>
          </div>
          <div class="flex flex-col">
            <span>Highest number alerts</span>
            <div class="flex gap-2 flex-wrap items-center">
              <span class="font-bold">{{ getZoneWithMostAlerts().count }}</span>
              <span class="underline text-xs italic"
                >({{ getZoneWithMostAlerts().name }})</span
              >
            </div>
          </div>
        </div>
      </div>

      <app-radialbars-graph
        *ngIf="showChart"
        [data]="radialData"
        [height]="400"
      >
      </app-radialbars-graph>
    </div>

    <div class="p-2 mt-3">
      <span class="font-bold"
        >Top 5 Warehouse Zones with stable environment</span
      >
      <div class="flex flex-col gap-2 mt-2">
        <div
          *ngFor="let zone of topStableZones; let i = index"
          class="flex items-center gap-2"
        >
          <span class="font-bold">{{ i + 1 }}.</span>
          <div
            class="grow bg-gray-50 rounded-lg flex justify-between items-center flex-wrap p-2"
          >
            <span>{{ zone.zone_name }}</span>
            <span
              class="px-1.5 rounded-full text-sm py-0.5"
              [ngClass]="{
                'bg-green-500': zone.stability_score >= 90,
                'bg-orange-500':
                  zone.stability_score >= 70 && zone.stability_score < 90,
                'bg-red-500': zone.stability_score < 70
              }"
            >
              {{ zone.stability_score | number : "1.0-0" }}%
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>